import { createContext } from 'react';

const ProjectContext = createContext({ services: [] });

export default ProjectContext;
